<div data-test="modal-cookies" class="text">
    {{message}}
</div>
<div mat-dialog-actions align="end" class="button">
<button data-test="btn-aceitar-cookies" mat-raised-button color="primary" mat-dialog-close tabindex="-1" (click)="onConfirmClick()">{{acceptButtonText}}</button>
</div>